import { Box, Text } from '@ltvco/refresh-lib/theme';
import { usePermissions } from '@ltvco/refresh-lib/ctx';
import { useSession } from '@ltvco/refresh-lib/v1';
import { FreeUserRewardContainer } from './FreeUserRewardContainer';
import { PremiumUserRewardContainer } from './PremiumUserRewardContainer';

export const Rewards = () => {
  const { isPremiumFeatureAllowedForFreePlanUsers } = usePermissions();
  const {
    session: { account },
  } = useSession();
  const cannotAccessRewards =
    !isPremiumFeatureAllowedForFreePlanUsers('rewards_access') &&
    account?.account?.subscription_info?.free_user;

  return (
    <Box>
      <Text variant="h3" mb={2.5} mt={1.5}>
        Rewards
      </Text>
      {cannotAccessRewards ? (
        <FreeUserRewardContainer displayCTABanner={true} />
      ) : (
        <PremiumUserRewardContainer />
      )}
    </Box>
  );
};
